@let addressForm = addressInput();
<fieldset>
    <input
        type="hidden"
        [formField]="addressForm.countryCode"
        autocomplete="country"
        class="form-row"
        id="countryCode"
    />
    @for (addressLine of addressFormat(); track addressLine.fields) {
        <div class="form-row row-container d-flex flex-column flex-sm-row">
            @for (field of addressLine.fields; track field) {
                <div class="form-group col">
                    <label
                        [for]="field.id"
                        class="form-label"
                        [style.display]="
                            field.showLabel === true ? 'block' : 'none'
                        "
                        [class.required]="addressForm[field.id]().required()"
                    >
                        {{ field.label | translate }}
                    </label>
                    @if (
                        field instanceof DropdownAddressFieldInfo
                    ) {
                        <select
                            class="form-select"
                            [id]="field.id"
                            [formField]="addressForm[field.id]"
                            [autocomplete]="field.autocomplete"
                        >
                            @for (option of field.options; track option.value) {
                                <option [value]="option.value">
                                    {{ option.label }}
                                </option>
                            }
                        </select>
                        @if (
                            addressForm[field.id]().touched() &&
                            addressForm[field.id]().invalid()
                        ) {
                            <ul class="error-list">
                                @for (
                                    error of addressForm[field.id]().errors();
                                    track error.message
                                ) {
                                    <li>{{ error.message | translate }}</li>
                                }
                            </ul>
                        }
                    } @else if (
                        field instanceof TextAddressFieldInfo
                    ) {
                        <input
                            type="text"
                            class="form-control"
                            [id]="field.id"
                            [formField]="addressForm[field.id]"
                            (input)="
                                field.id === 'postalCode'
                                    ? ($event.target.value =
                                          $event.target.value.toUpperCase())
                                    : null
                            "
                        />
                        @if (
                            addressForm[field.id]().touched() &&
                            addressForm[field.id]().invalid()
                        ) {
                            <ul class="error-list">
                                @for (
                                    error of addressForm[field.id]().errors();
                                    track error.message
                                ) {
                                    <li>
                                        {{ error.message | translate }}
                                        @if (error.example) {
                                            {{
                                                "addressing.example"
                                                    | translate
                                            }}:
                                            {{ error.example }}
                                        }
                                    </li>
                                }
                            </ul>
                        }
                    }
                </div>
            }
        </div>
    }
</fieldset>
